import { RankingChartComponent } from './ranking-chart/ranking-chart.component'
import { LineChartComponent } from './line-chart/line-chart.component'
import { HeatMapComponent } from './heat-map/heat-map.component'
import { TranslateModule } from '@ngx-translate/core'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BarChartComponent } from './bar-chart/bar-chart.component'

const modules = [
  BarChartComponent,
  HeatMapComponent,
  LineChartComponent,
  RankingChartComponent,
]

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [...modules],
  exports: [...modules],
})
export class ChartModule {}
